import React from 'react';

import StrokeIcon, { StrokeIconProps } from './StrokeIcon';

export default function MinusIcon(props: StrokeIconProps): JSX.Element {
  return (
    <StrokeIcon {...props}>
      <path d="M5 12h14" />
    </StrokeIcon>
  );
}
